const initialState = [
  {
    QRData: [],
  },
];

const qrCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "QR_CODE_GENRATOR":
      return {
        ...state,
        QRData: action.payload,
      };
    default:
      return state;
  }
};

export default qrCodeReducer;
